import { Component,  Input, EventEmitter, Output, OnInit } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'joi-message',
    template: `
<div *ngIf="message" class="joi-message">
  <div class="message-holder">{{ message }}</div>
  <div style="flex:1;"></div>
  <icon class="close" icon="close" (click)="close.emit()"></icon>
</div>
`,
    styleUrls: ['./joi-message.scss'],
    standalone: true,
    imports: [IconComponent, CommonModule],
})

export class JoiMessageComponent {
  @Input() message
  @Output() close: EventEmitter<void> = new EventEmitter()
}

